module.exports = __webpack_public_path__ + "img/CustomDevices.bcf26c6e.svg";